module.exports = __webpack_public_path__ + "static/media/PoppinsMedium.e29fe29a.woff2";